import { create } from 'zustand'

interface WsState {
  connected: boolean
  reconnectAttempts: number
  /**
   * Live reference to the global WebSocket created by `useWebSocket`.
   * Pages that want to subscribe to channel-scoped events (e.g.
   * `content_session_spend_update` or `build_spend_update`) read this
   * instead of opening their own socket. Null until the first connect or
   * after an unrecoverable close.
   */
  socket: WebSocket | null
  setConnected: (connected: boolean) => void
  setSocket: (socket: WebSocket | null) => void
  incrementReconnect: () => void
  resetReconnect: () => void
}

export const useWsStore = create<WsState>((set) => ({
  connected: false,
  reconnectAttempts: 0,
  socket: null,
  setConnected: (connected) => set({ connected }),
  setSocket: (socket) => set({ socket }),
  incrementReconnect: () => set((s) => ({ reconnectAttempts: s.reconnectAttempts + 1 })),
  resetReconnect: () => set({ reconnectAttempts: 0 }),
}))
